// @flow
import NestedResource from 'speed-js-core/src/api/NestedResource';

export default class NomenclatureItemResource extends NestedResource {
    basePath: string = 'nomenclatures/types/{parent}/items/';

    objectPath: string = 'nomenclatures/types/{parent}/items/{ident}/';
}
